import { createTheme } from '@mui/material'

// https://coolors.co/palette/361c07-533113-8c5c2b-9c7744-eae5d6-e0e3ca-b4c187-80914b-5a6b3a-496231
export const lightTheme = createTheme({
    palette: {
        primary: {
            main: '#9c7744',
        },
        secondary: {
            main: '#80914b',
        },
        background: {
            primary: {
                main: '#E0E3CA',
            },
            secondary: {
                main: '#EAE5D6',
            },
        },
    },
})
